/**
 * Tools Entry Point
 *
 * Detects which tool page is active and initializes the corresponding module.
 */

import { initPanicCoach } from './panic-coach';
import { initMicroBreak } from './micro-break';
import { initMindfulnessSprint } from './mindfulness-sprint';
import { initWorryCapture } from './worry-capture';
import { initMicroGratitude } from './micro-gratitude';

document.addEventListener('DOMContentLoaded', function () {
    var toolEl = document.querySelector('.tool-single');
    if (!toolEl) return;

    var slug = toolEl.dataset.tool;

    var initializers = {
        'panic-coach': initPanicCoach,
        'micro-break': initMicroBreak,
        'mindfulness-sprint': initMindfulnessSprint,
        'worry-capture': initWorryCapture,
        'micro-gratitude': initMicroGratitude,
    };

    if (initializers[slug]) {
        initializers[slug]();
    }
});
